import { render } from "./UserDetailsComponent.vue?vue&type=template&id=14338122&scoped=true"
import script from "./UserDetailsComponent.vue?vue&type=script&lang=js"
export * from "./UserDetailsComponent.vue?vue&type=script&lang=js"

import "./UserDetailsComponent.vue?vue&type=style&index=0&id=14338122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14338122"]])

export default __exports__